import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

interface RippleWaveLoaderProps {
  messages?: string[];
  message?: string;
}

export default function RippleWaveLoader({ messages, message }: RippleWaveLoaderProps) {
  const allMessages = messages ?? (message ? [message] : []);
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    if (allMessages.length <= 1) return;
    const id = setInterval(() => {
      setMsgIndex(i => (i + 1) % allMessages.length);
    }, 2200);
    return () => clearInterval(id);
  }, [allMessages.length]);

  return (
    <div className="flex flex-col items-center justify-center gap-5 py-4">
      <div className="flex items-center justify-center space-x-1">
        {[...Array(7)].map((_, index) => (
          <motion.div
            key={index}
            className="h-8 w-2 rounded-full"
            style={{ background: 'linear-gradient(180deg, #FF541F 0%, #FF3C00 100%)' }}
            animate={{
              scaleY: [0.5, 1.5, 0.5],
              scaleX: [1, 0.8, 1],
              translateY: ['0%', '-15%', '0%'],
            }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: index * 0.1,
            }}
          />
        ))}
      </div>
      {allMessages.length > 0 && (
        <motion.p
          key={msgIndex}
          initial={{ opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="text-sm text-gray-400 text-center"
        >
          {allMessages[msgIndex]}
        </motion.p>
      )}
    </div>
  );
}
